import { classNames } from '../utils/UNSAFE_classNames';
import { cssProps } from '@oracle/oraclejet-cssprops';

const textFieldStyles = {
  base: cssProps`${{
    display: 'inline-block',
    lineHeight: 'var(--oj-c-PRIVATE-DO-NOT-USE-typography-body-md-line-height)',
    maxWidth: '100%',
    width: '100%',
    boxSizing: 'border-box'
  }}`,

  embedded: cssProps`${{
    height: '100%'
  }}`,

  nonReadonly: cssProps`${{
    fontWeight: '400',
    fontSize: 'var(--oj-c-PRIVATE-DO-NOT-USE-text-field-font-size)'
  }}`
};

const readonlyStyles = {
  base: cssProps`${{
    fontWeight: 'var(--oj-form-control-font-weight-read-only)',
    fontSize: 'var(--oj-c-PRIVATE-DO-NOT-USE-typography-body-md-font-size)',
    position: 'relative',
    borderStyle: 'solid',
    transitionProperty: 'border-color',
    transitionDuration: '0.1s',
    transitionTimingFunction: 'linear',
    borderRadius: 'var(--oj-c-PRIVATE-DO-NOT-USE-text-field-border-radius)',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '100%',
    width: '100%',
    boxSizing: 'border-box'
  }}`,

  insideEnabledForm: cssProps`${{
    overflowX: 'hidden',
    overflowY: 'hidden',
    borderWidth: 'var(--oj-c-PRIVATE-DO-NOT-USE-text-field-border-width)',
    borderColor: 'var(--oj-c-PRIVATE-DO-NOT-USE-text-field-border-color-disabled)',
    backgroundColor: 'transparent',
    height: 'var(--oj-c-PRIVATE-DO-NOT-USE-text-field-height)',
    minWidth: '1em',
    display: 'inline-flex',
    flex: '1'
  }}`,

  textarea: cssProps`${{
    height: 'auto'
  }}`,

  insideEnabledFormLabelInside: cssProps`${{
    minHeight: 'var(--oj-c-PRIVATE-DO-NOT-USE-text-field-inside-edge-height)'
  }}`,

  notInsideEnabledForm: cssProps`${{
    overflowX: 'visible',
    overflowY: 'visible',
    borderWidth: '0',
    backgroundColor: 'transparent',
    height: 'auto'
  }}`,

  textareaNotInsideEnabledForm: cssProps`${{
    paddingTop: '0',
    paddingBottom: '0'
  }}`
};

//Consolidating all loading styles on form elements here
export const loadingStyles = cssProps`${{
  backgroundColor: 'var(--oj-c-PRIVATE-DO-NOT-USE-animation-skeleton-bg-end-color)',
  backgroundSize: '200% 200%',
  borderWidth: '0',
  // need to use a var for the animation name because otherwise linaria will obfuscate it
  // and make it different from the actual keyframes name
  animationName: 'var(--oj-c-PRIVATE-DO-NOT-USE-private-preact-text-field-animation-name-skeleton)',
  animationIterationCount: 'infinite',
  animationDirection: 'alternate',
  animationDuration: '1.5s',
  opacity: '1'
}}`;

export const getTextFieldClasses = (readonly?: boolean, variant?: 'default' | 'embedded') => {
  return classNames([
    textFieldStyles.base,
    variant === 'embedded' && textFieldStyles.embedded,
    !readonly && textFieldStyles.nonReadonly
  ]);
};

export const getReadonlyClasses = (
  isInsideNonReadonlyForm?: boolean,
  hasInsideLabel?: boolean,
  variant?: 'textarea'
) => {
  const classes = classNames([
    readonlyStyles.base,
    variant === 'textarea' && readonlyStyles.textarea,
    isInsideNonReadonlyForm
      ? readonlyStyles.insideEnabledForm
      : readonlyStyles.notInsideEnabledForm,
    variant === 'textarea' &&
      !isInsideNonReadonlyForm &&
      readonlyStyles.textareaNotInsideEnabledForm,
    isInsideNonReadonlyForm && hasInsideLabel && readonlyStyles.insideEnabledFormLabelInside
  ]);
  return classes;
};

export const getInputId = (id?: string) => {
  return (id ?? '') + '|input';
};

export const isInputPlaceholderShown = (
  hasInsideLabel: boolean,
  hasValue: boolean,
  isFocused?: boolean
) => {
  return !(hasInsideLabel && !hasValue && !isFocused);
};
